module.exports = {
    CM_BROKER_PG_URL: '/myprofile/broker',
    CM_CUSTOM_WALLET_CONFIG_URL: '/myprofile/broker/custom-portfolio',
    CM_WIZARD_FIRST_STEP: 0,
    CM_WIZARD_SECOND_STEP: 1,
    CM_WIZARD_THIRD_STEP: 2,
    CM_CONTRACT_OWNER: 'broker-stocksContractOwner',
    CM_EUR_CURRENCY_SYMBOL: '€',
    CM_EUR_CURRENCY: 'EUR',
    CM_ACTIVE_FUND_TYPE: 'A',
    CM_PASIVE_FUND_TYPE: 'P',
    CM_ACTIVE_FUND_TYPE_TAG: 'activa',
    CM_PASIVE_FUND_TYPE_TAG: 'pasiva',
    CM_DIY_TAG: 'personalizada',
    CM_CUSTOMIZED: 'true',
    CM_PUBLIC_ACTIVE_FUND_TYPE: 'ActiveFunds',
    CM_API_CENTER: '0100',
    CM_API_ENTERPRISE_NUMBER: '0073',
    CM_OPERATION_ID: 129,
    CM_ACTIVE_CLASS_MONEY_MARKET: 'AC001',
    CM_ACTIVE_CLASS_FIXED_INCOME: 'AC002',
    CM_ACTIVE_CLASS_EQUITY: 'AC003',
    CM_ACTIVE_CLASS_REAL_ASSETS: 'AC004',
    CM_STEP1_AMOUNT_MIN: 0,
    CM_STEP1_AMOUNT_MAX: 5000000,
    CM_INTERVENER_ITEM_TITULAR: 'TITULAR',
    CM_INTERVENER_ITEM_AUTORIZADO: 'AUTORIZADO',
    CM_INTERVENER_ITEM_REP: 'REPRESENTANTE LEGAL',
    CM_INTERVENER_ITEM_ADMIN: 'ADMINISTRADOR',
    CM_INTERVENER_ITEM_APODERADO: 'APODERADO',
    CM_GDPR_PID: 'cm',
    CM_TRANSFER_TAX_EXEMPT_FALSE: 'N',
    CM_TRANSFER_TAX_EXEMPT_TRUE: 'S',
    CHANGE_AGENT_ID: 'WEB',
    CM_BUY_TYPE_MONEY: 'MONEY',
    CM_BUY_TYPE_TRANSFER: 'TRANSFER',
    CM_BUY_TYPE_TRANSFER_MONEY: 'TRANSFER-MONEY',
    CM_TRANSFER_FUND_TO_EXISTING_ACCOUNT: 'TR-CE',
    CM_OPERATION_TYPE_TRASPASS: 'TR',
    CM_OPERATION_TYPE_TRASPASS_NA: 'TR-NA',
    CM_ADDITIONAL_SUBSCRIPTION_OPERATION_TYPE: 'SU',
    CM_HIRE_OPERATION_TYPE: 'CO',
    CM_ICON_ERROR: 'error',
    CM_ICON_SUCCESS: 'exito',
    CM_TRASPASS_FORMAT_CCC: [4, 4, 2],
    CM_PROC_BUY_FUND: 'comprar fondos',
    CM_PROC_MONEY: 'solo liquidez',
    CM_PROC_TRANSFER: 'solo traspaso',
    CM_PROC_MONEY_TRANSFER: 'traspaso y liquidez',
    CM_PROC_INIT: 'inicio',
    CM_PROC_SUCCESS: 'exito',
    CM_PROC_TRANSFER_ORDER: 'orden de traspaso',
    CM_PROC_MONEY_TRANSFER_ORDER: 'orden de liquidez',
    CM_PROC_BUY_FUND_MODAL: 'abandono compra fondos',
    CM_PROC_BUY_FUND_MODAL_CONTINUE: 'continuar',
    CM_PROC_BUY_FUND_MODAL_LEAVE: 'abandonar',
    CM_PROC_BUY_FUND_MODAL_CLOSE: 'cerrar modal',
    CM_PROC_BUY_FUND_ORDERS_OK: 'ordenes enviadas',
    CM_PROC_BUY_FUND_ORDERS_NOK: 'ordenes no enviadas',
    CM_FILTERS_ALL_OPTIONS_VALUE: 0,
};
